import { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"

export const useSitePages = () => {
  const [sitePages, setSitePages] = useState([])

  const data = useStaticQuery(graphql`
    query {
      allSitePage {
        nodes {
          pageContext
          path
        }
      }
    }
  `)

  useEffect(() => {
    setSitePages(data?.allSitePage?.nodes)
  }, [data])

  return sitePages
}
